import { FilterPrimaryUseClassEnum } from '@/bundles/GroupFilters/types';

export const FilterPrimaryUseClassItems = [
  { text: 'Primary', value: FilterPrimaryUseClassEnum.primary },
  { text: 'Either', value: FilterPrimaryUseClassEnum.either },
  { text: 'Secondary', value: FilterPrimaryUseClassEnum.secondary },
];
